export default {"src":"/_next/static/media/dviz.319e6dc7.svg","height":30,"width":77};